import {createContext, useReducer, useState} from "react";
import useLocalstorage from "../utils/CustomHooks/useLocalstorage/useLocalstorage";

const AuthContext = createContext({});

const GET_NEW_DATA = 'getNewData';
const CHANGE_TOGGLE_BACK_PAGE = 'changeToggleBackPage';
const UPDATE_REQUEST_DICTIONARY = 'updateRequestDictionary';
const UPDATE_REQUEST_FILES = 'updateRequestFiles';
const UPDATE_REQUEST_USERS = 'updateRequestUsers';
const GET_ID_BOL_LIST = 'getIdBolList';
const GET_ID_CREATE_DOC = 'getIdCreateDoc';
const GET_ID_UPDATE_BOL = 'getIdUpdateBol';
const GET_ID_UPDATE_MAN = 'getIdUpdateMan';
const GET_ID_SELECT_DOC = 'getIdSelectDoc';
const CLEAN_ID_CREATE_DOC = 'cleanIdCreateDoc';
const CLEAN_ID_UPDATE_BOL = 'cleanIdUpdateBol';
const CLEAN_ID_UPDATE_MAN = 'cleanIdUpdateMan';
const CLEAN_ID_SELECT_DOC = 'cleanIdSelectDoc';

const initialState = {
    request: false,
    toggleBackPage: true,
    updateRequestDictionary: true,
    updateRequestFiles: true,
    updateRequestUsers: true,
    idCreateDoc: null,
    idUpdateBol: null,
    idUpdateMan: null,
    selectBolList: null,
    idSelectDoc: {}
}

const reducer = (state, action) => {
    switch (action.type) {
        case GET_NEW_DATA : return {...state, request: !state.request}
        case UPDATE_REQUEST_DICTIONARY : return  {...state, updateRequestDictionary: !state.updateRequestDictionary}
        case UPDATE_REQUEST_FILES : return  {...state, updateRequestFiles: !state.updateRequestFiles}
        case UPDATE_REQUEST_USERS : return {...state, updateRequestUsers: !state.updateRequestUsers}
        case CHANGE_TOGGLE_BACK_PAGE : return {...state, toggleBackPage: !state.toggleBackPage}
        case GET_ID_BOL_LIST : return {...state, selectBolList: action.selectBolList}
        case GET_ID_CREATE_DOC : return {...state, idCreateDoc: action.idCreateDoc}
        case GET_ID_UPDATE_BOL : return {...state, idUpdateBol: action.idUpdateBol}
        case GET_ID_UPDATE_MAN : return {...state, idUpdateMan: action.idUpdateMan}
        case GET_ID_SELECT_DOC : return {...state, idSelectDoc: action.idSelectDoc}
        case CLEAN_ID_CREATE_DOC : return {...state, idCreateDoc: null}
        case CLEAN_ID_UPDATE_BOL : return {...state, idUpdateBol: null}
        case CLEAN_ID_UPDATE_MAN : return {...state, idUpdateMan: null}
        case CLEAN_ID_SELECT_DOC : return {...state, idSelectDoc: {}}
        default : return state
    }
}

export  const AuthProvider = ({children}) => {
    const [auth, setAuth] = useLocalstorage({}, 'user');
    const [isLoggedIn, setLoggedIn] = useLocalstorage({}, 'logged');
    const [dictionaryCountries, setDictionaryCountries] = useState([]);
    const [dictionaryVessels, setDictionaryVessels] = useState([]);
    const [dictionaryOrg, setDictionaryOrg] = useState([]);
    const [dictionaryCities, setDictionaryCities] = useState([]);
    const [dictionaryPorts, setDictionaryPorts] = useState([]);
    const [dictionaryCaptains, setDictionaryCaptains] = useLocalstorage([], 'dictionaryCaptains');
    const [dictionaryConsignee, setDictionaryConsignee] = useState([]);
    const [nameDocHeader, setNameDocHeader] = useState('');
    const [stateReducer, dispatch] = useReducer(reducer, initialState);

    const getRequestDataToggle = () => dispatch({ type: GET_NEW_DATA })
    const updateRequestDataDictionary = () => dispatch({ type: UPDATE_REQUEST_DICTIONARY })
    const updateRequestFiles = () => dispatch({ type: UPDATE_REQUEST_FILES })
    const updateRequestUsers = () => dispatch({ type: UPDATE_REQUEST_USERS })
    const changeToggleBackPage = () => dispatch({ type: CHANGE_TOGGLE_BACK_PAGE })
    const getIdCreateDoc = (idCreateDoc) => dispatch({ type: GET_ID_CREATE_DOC, idCreateDoc })
    const getIdUpdateBol = (idUpdateBol) => dispatch({ type: GET_ID_UPDATE_BOL, idUpdateBol })
    const getIdUpdateMan = (idUpdateMan) => dispatch({ type: GET_ID_UPDATE_MAN, idUpdateMan })
    const getIdSelectDoc = (idSelectDoc) => dispatch({ type: GET_ID_SELECT_DOC, idSelectDoc}) 
    const cleanIdCreateDoc = () => dispatch({ type: CLEAN_ID_CREATE_DOC })
    const cleanIdUpdateBol = () => dispatch({ type: CLEAN_ID_UPDATE_BOL })
    const cleanIdUpdateMan = () => dispatch({ type: CLEAN_ID_UPDATE_MAN })
    const cleanIdSelectDoc = () => dispatch({ type: CLEAN_ID_SELECT_DOC })

    return (
        <AuthContext.Provider value={{
            auth,
            setAuth,
            isLoggedIn,
            setLoggedIn,
            dictionaryCountries,
            setDictionaryCountries,
            dictionaryVessels,
            setDictionaryVessels,
            dictionaryOrg,
            setDictionaryOrg,
            dictionaryCities,
            setDictionaryCities,
            dictionaryPorts,
            setDictionaryPorts,
            dictionaryCaptains,
            setDictionaryCaptains,
            dictionaryConsignee,
            setDictionaryConsignee,
            nameDocHeader,
            setNameDocHeader,
            stateReducer,
            getRequestDataToggle,
            updateRequestDataDictionary,
            updateRequestFiles,
            updateRequestUsers,
            changeToggleBackPage,
            getIdCreateDoc,
            getIdUpdateBol,
            getIdUpdateMan,
            getIdSelectDoc,
            cleanIdCreateDoc,
            cleanIdUpdateBol,
            cleanIdUpdateMan,
            cleanIdSelectDoc
        }}>
            {children}
        </AuthContext.Provider>
    )
}
export default AuthContext;